export const logout = () => {
    return function (dispatch) {
        dispatch(userLogout());
    }
}

const userLogout = () => ({
    type: 'USER_LOGOUT',
    logoutAt: Date.now()
});